<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GNhuvj/tc-custom/9781503611108.jpg?1705766127810" alt="This image is the cover for the book Food in Cuba"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Food in Cuba
      </h1>
      <p class="bookDescription body article font2">
        <b>“Garth’s in-depth and intimate ethnography portrays the shortcomings in Cuba’s welfare system, and the profound consequences for the way people eat.” —Megan A. Carney, author of <i>The Unending Hunger</i></b><br/><br/><i>Food in Cuba</i> follows Cuban families as they struggle to maintain a decent quality of life in Cuba’s faltering, post-Soviet welfare state by looking at the social and emotional dimensions of food access. Based on extensive fieldwork with families in Santiago de Cuba, Hanna Garth examines Cuban families’ attempts to acquire and assemble “a decent meal,” unraveling the household dynamics, community interactions, and individual reflections on everyday life in today’s Cuba. <br/><br/>With the collapse of the Soviet Union in the 1990s, Cuba lost its most significant trade partner. Although trade agreements have improved the quantity and quality of rationed food in Cuba, many Cubans still report living with food shortages and economic hardship. <br/><br/>Garth tells the stories of families that face the daily challenge of acquiring not only enough food, but food that meets personal and cultural standards. She argues that these ongoing struggles produce what the Cuban families describe as “a change in character,” and that for some, this shifting concept of self leads to a transformation of Cuban identity.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hanna Garth
      </h2>
      
      <p class="authorDescription body article"><B>Hanna Garth</B> is Assistant Professor of Anthropology at the University of California, San Diego.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stanford University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3905e1d0